// extracted by mini-css-extract-plugin
export default {"center":"NewsPreview_center__bZ7zw","item":"NewsPreview_item__jytuW"};